import React from 'react'
import ReportingCycleEditor from './editor'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'

class ReportingCycleDetailForm extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      reportingCycle: props.reportingCycle
    }
  }
  render () {
    const { year, localize, reportingCycle, disabled } = this.props
    const confirmText = reportingCycle.hasSubmissionParameters ? 'Reporting.SubmissionParametersDeletionWarning' : 'Reporting.RecalculateDatesWarning'
    return (
      <React.Fragment>
        <ReportingCycleEditor
          localize={localize}
          year={year}
          disabled={disabled}
          reportingCycle={reportingCycle}
          onChange={data => this.setState({ reportingCycle: data })} />

        <div className='mt-4'>
          <Button
            disabled={disabled}
            color='success'
            icon='save'
            confirmText={confirmText}
            onClick={() => this.props.onSave(this.state.reportingCycle)}>{localize('Reporting.SaveAndRecalculate')}</Button>
          {reportingCycle.hasSubmissionParameters && <Icon name='error-circle' style={{ marginLeft: 10 }} title={localize('Reporting.SubmissionsHaveParametersTooltipWarning')} />}
        </div>
      </React.Fragment>
    )
  }
}

export {
  ReportingCycleDetailForm
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/form.js